import UnitDto, { UnitType } from './dtos/UnitDto';

export function unitList(): Array<UnitDto> {
  return [
    { value: "Pound", name: "Pound", type: UnitType.Mass },
    { value: "Gallon", name: "Gallon", type: UnitType.Volume },
    { value: "Ounce", name: "Ounce", type: UnitType.Mass },
    { value: "Kilogram", name: "Kilogram", type: UnitType.Mass },
    { value: "Pint", name: "Pint", type: UnitType.Volume },
    { value: "Quart", name: "Quart", type: UnitType.Volume },
    { value: "Liter", name: "Liter", type: UnitType.Volume },
    { value: "Ton", name: "Ton", type: UnitType.Mass },
    { value: "FluidOunce", name: "Fluid ounce", type: UnitType.Volume },
    { value: "CubicFoot", name: "Cubic foot", type: UnitType.Volume },
    { value: "MetricTon", name: "Metric ton", type: UnitType.Mass },
  ];
}

export function toAbbreviation(unit: string) {
  switch (unit) {
    case "Pound": return "lb";
    case "Gallon": return "gal";
    case "Ounce": return "oz";
    case "Kilogram": return "kg";
    case "Pint": return "pt";
    case "Quart": return "qt";
    case "Liter": return "L";
    case "Ton": return "ton";
    case "FluidOunce": return "fl oz";
    case "CubicFoot": return "cu ft";
    case "MetricTon": return "t";
    default: return "Unknown";
  }
}
